export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14529.dace4dc4.jpg";